import {
  ExperienceDto,
  ExperiencePageTargetingDto,
  OrganizationDto,
  RedirectDto,
} from "@intelligems/ig-types";
import { getPreviewPathShared } from "@intelligems/ig-utils";

export const getPreviewThemeId = (
  themeRedirects: RedirectDto[],
  variationId?: string
) => {
  if (themeRedirects.length === 0) {
    return "";
  }

  let themeRedirect = themeRedirects[0];
  if (variationId) {
    themeRedirect =
      themeRedirects.find((redirect) => redirect.variationId === variationId) ||
      themeRedirects[0];
  }
  return themeRedirect.queryParams.length &&
    themeRedirect.queryParams[0].value !== undefined
    ? themeRedirect.queryParams[0].value
    : "";
};

export const generatePreviewLink = ({
  organization,
  experience,
  previewThemeId,
  variationId,
  addSsTrafficDetails,
  customDevicePath,
  builderModeEntity,
  authToken,
  useOriginUrl,
  redirects,
  pageTargeting,
}: {
  organization: OrganizationDto;
  experience: Pick<ExperienceDto, "devicePreview" | "previewPath"> & {
    id?: string;
  };
  variationId?: string;
  previewThemeId?: string;
  addSsTrafficDetails?: boolean;
  customDevicePath?: string;
  builderModeEntity?: string;
  authToken?: string | null;
  useOriginUrl?: boolean;
  redirects?: RedirectDto[];
  pageTargeting?: ExperiencePageTargetingDto[];
}) => {
  if (variationId !== undefined) {
    redirects = (redirects || []).filter((r) => r.variationId === variationId);
  }
  const redirectPreview = getPreviewPathShared(
    redirects || [],
    pageTargeting || [],
    useOriginUrl
  );
  let localPath = customDevicePath
    ? customDevicePath
    : experience.devicePreview?.path && experience.devicePreview.path !== "/"
      ? experience.devicePreview.path
      : (redirects && redirects.length) ||
          (pageTargeting && pageTargeting.length)
        ? redirectPreview
        : experience.previewPath;

  if (localPath) {
    localPath = localPath.replace(/^\/*/, "");
  }

  const params: Record<string, string> = { "ig-preview": experience.id! };
  if (variationId) {
    params["igTg"] = variationId;
  }

  if (addSsTrafficDetails) {
    params["ig-ss"] = "true";
    params["ig-preview-traffic"] = "true";
  }

  if (previewThemeId) {
    params["preview_theme_id"] = previewThemeId;
  }

  if (builderModeEntity && authToken) {
    params["ig-builder-mode"] = "builder";
    params["ig-builder-entity"] = builderModeEntity;
    params["ig-auth-token"] = authToken;
  }

  // Construct the base URL
  const baseUrl = localPath?.includes("https://")
    ? ""
    : (organization.domain ?? organization.shopId);

  const httpsUrl = baseUrl?.startsWith("https://")
    ? baseUrl
    : `https://${baseUrl}`;
  const url = new URL(
    `${httpsUrl}/${localPath?.replace("https://", "") || ""}`
  );

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  return url.href;
};
